import '../css/ExpandableProjectList.less';

import * as React from 'react';
import {Link} from 'react-router-dom';
import {Button, Card} from 'semantic-ui-react';

import emptyImg from '../assets/il-no-projects.png';
import emptyImg2x from '../assets/il-no-projects@2x.png';
import ImageIconHeader from '../components/ImageIconHeader';
import ProjectCard from '../components/ProjectCard';
import {isFeatureFlagEnabled} from '../util/featureFlags';
import {Graph} from '../types/graphql';
import {allProjects, newBenchmarkPage, newProjectPage} from '../util/urls';
import EmptyWatermark from './EmptyWatermark';
import {Project} from '../graphql/allProjectsQuery';
import makeComp from '../util/profiler';

interface ExpandableProjectListProps {
  projects: Graph<Project>;
  entityName: string;
  readOnly?: boolean;
}

const ExpandableProjectList: React.FC<ExpandableProjectListProps> = makeComp(
  ({projects, entityName, readOnly}) => {
    const enableCreateBenchmark = isFeatureFlagEnabled({
      featureKey: entityName,
      featureName: 'create-benchmark',
    });
    return (
      <div className="expandable-project-list-wrapper">
        <div className="header-wrapper">
          <ImageIconHeader icon="project" text="Projects" />
          {!readOnly && (
            <div>
              {enableCreateBenchmark && (
                <Link to={newBenchmarkPage(entityName)}>
                  <Button size="tiny" style={{marginRight: 12}}>
                    Create new benchmark
                  </Button>
                </Link>
              )}
              <Link to={newProjectPage(entityName)}>
                <Button primary size="tiny">
                  Create new project
                </Button>
              </Link>
            </div>
          )}
        </div>
        {projects.edges.length > 0 ? (
          <div className="expandable-project-list">
            <Card.Group>
              {projects.edges.slice(0, 6).map(p => (
                <ProjectCard
                  key={p.node.id}
                  project={p.node}
                  readOnly={readOnly}
                />
              ))}
            </Card.Group>
            <a className="see-all-link" href={allProjects(entityName)}>
              See all ➞
            </a>
          </div>
        ) : (
          <EmptyWatermark
            imageSource={emptyImg}
            imageSource2x={emptyImg2x}
            header="No projects yet."
            details={
              readOnly
                ? "This user or team hasn't created any projects yet."
                : 'Create a project to start tracking your experiments.'
            }
            wide
          />
        )}
      </div>
    );
  },
  {id: 'ExpandableProjectList'}
);
export default ExpandableProjectList;
